import { render } from "./test.vue?vue&type=template&id=213b47f4&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=213b47f4&scoped=true&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213b47f4"]])

export default __exports__